<template>
    <div class="c-services component">
        <h3 class="text-upper mb--2">USŁUGI DO WYKONANIA</h3>
        <label class="c-services__item flex-row pointer" v-for="service in getServices">
            <div class="flex-col flex-col--1 flex-row flex-row--space-around">
                <input type="checkbox" :val="service.val" class="mt--1" v-on:change="pushService(service)">
                <img :src="service.icon" :alt="service.name" class="c-services__icon">
            </div>
            <div class="flex-col flex-col--9">
                <strong>{{ service.name }}</strong><br>
                {{ service.text }}
            </div>
        </label>
    </div>
</template>
<script>

import {mapActions,mapGetters} from 'vuex';

import lead from '@/mixins/lead.js'

export default {
    computed:{
        ...mapGetters({
            getServices: 'definitions/getServices'
        })
    },
    mixins:[lead],
    methods:{
        pushService(service){
            let id = this.lead.services_val.indexOf(service.val);
            if(id != -1){
                this.lead.services_val.splice(id, 1);
            }else{
                this.lead.services_val.push(service.val)
            }
        }
    }
}
</script>
<style lang="scss">
    .c-services{
        &__item{
            margin-bottom: .5rem;

        }
        &__icon{
            width: 35px;
            height: 35px;
            image-rendering: pixelated;
        }
    }
</style>